import { newWorkflowKey } from "./tabId";

const ABANDON_WORDS = /\b(cancel|close|closebutton|dismiss|discard|back|no|x)\b/i;
const ABANDON_SYMBOLS = ["×", "✕", "✖"];
const FINISH_WORDS = /\b(save|submit|create|apply|confirm|update|add|done|ok|send|run|load)\b/i;

const words = (text) =>
  String(text || "")
    .replace(/^[^.]*\./, (prefix) => (/\s/.test(prefix) ? prefix : ""))
    .replace(/[._-]+/g, " ")
    .replace(/([a-z])([A-Z])/g, "$1 $2")
    .trim();

export const AREA_TYPES = ["form", "section"];

export const isAreaType = (type) => AREA_TYPES.includes(type);

export const createWorkflowTracker = () => {
  const open = new Map();
  return {
    open: (name, type = "panel", page) => {
      const key = newWorkflowKey();
      open.set(name, { key, type, page });
      return key;
    },
    keyOf: (name) => (name && open.has(name) ? open.get(name).key : undefined),
    typeOf: (name) => (name && open.has(name) ? open.get(name).type : undefined),
    close: (name) => {
      const entry = open.get(name);
      open.delete(name);
      return entry ? entry.key : undefined;
    },
    closeAreasNotOn: (page) => {
      open.forEach((entry, name) => {
        if (isAreaType(entry.type) && entry.page !== page) open.delete(name);
      });
    },
  };
};

export const workflowOutcome = (closedBy, openedBy) => {
  if (!closedBy) return "closed";
  const label = words(closedBy);
  if (openedBy && closedBy === openedBy) return "abandoned";
  if (ABANDON_SYMBOLS.includes(String(closedBy).trim())) return "abandoned";
  if (ABANDON_WORDS.test(label) || ABANDON_WORDS.test(String(closedBy))) return "abandoned";
  return "completed";
};

export const isFinishWord = (closedBy) => FINISH_WORDS.test(words(closedBy));

export default workflowOutcome;
